//import store from './store'
import routes from "./router";

export default routes;
